var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.05 2H7.95C4.66391 2 2 4.66391 2 7.95V16.05C2 19.3361 4.66391 22 7.95 22H16.05C19.3361 22 22 19.3361 22 16.05V7.95C22 4.66391 19.3361 2 16.05 2Z",
    fill: "#424C9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78988 10.1504C7.39432 10.1504 7.00764 10.0331 6.67874 9.81333C6.34984 9.59357 6.0935 9.28121 5.94212 8.91576C5.79075 8.55031 5.75114 8.14817 5.82831 7.76021C5.90548 7.37225 6.09596 7.01588 6.37567 6.73618C6.65537 6.45647 7.01174 6.26599 7.3997 6.18882C7.78766 6.11165 8.1898 6.15126 8.55525 6.30263C8.9207 6.45401 9.23306 6.71035 9.45282 7.03925C9.67258 7.36815 9.78988 7.75483 9.78988 8.15039C9.78988 8.68082 9.57917 9.18953 9.2041 9.56461C8.82902 9.93968 8.32032 10.1504 7.78988 10.1504ZM21.9999 15.3904L19.7099 13.0804C19.4105 12.7748 19.0515 12.5341 18.6552 12.3731C18.2588 12.2122 17.8336 12.1344 17.406 12.1448C16.9783 12.1551 16.5574 12.2532 16.1693 12.4331C15.7811 12.613 15.4342 12.8707 15.1499 13.1904L13.1499 15.3604C12.9514 15.5828 12.7107 15.7636 12.4418 15.8922C12.1729 16.0209 11.8811 16.0948 11.5833 16.1096C11.2856 16.1245 10.9879 16.0801 10.7075 15.979C10.4271 15.8778 10.1695 15.7219 9.94988 15.5204C9.3973 15.0182 8.68341 14.7301 7.93706 14.7081C7.19072 14.6861 6.46109 14.9317 5.87988 15.4004L2.37988 18.2204C2.80733 19.3344 3.56305 20.2923 4.54699 20.9674C5.53092 21.6424 6.69667 22.0026 7.88988 22.0004H16.0999C17.6738 21.9742 19.1743 21.3305 20.278 20.2081C21.3817 19.0857 22.0001 17.5745 21.9999 16.0004V15.3904Z",
    fill: "#424C9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.c08c5dac01f32f055f5548406d237f79.svg";
export { ForwardRef as ReactComponent };